var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"index-game",on:{"click":_vm.gotoGame}}),_c('div',{staticClass:"index-rule",on:{"click":_vm.gotoRule}},[_vm._v("活动说明≫")])])}
var staticRenderFns = []

export { render, staticRenderFns }